export const reduceReadOrganizationTwilioRegistrationsSuccess = (
  state,
  { payload: { twilioRegistrations } },
) => {
  if (!Object.keys(twilioRegistrations).length || !state.base.allIDs.length) {
    return state;
  }

  const newById = { ...state.base.byId };
  Object.keys(twilioRegistrations).forEach((orgId) => {
    newById[orgId].twilioRegistrations = twilioRegistrations[orgId];
  });

  return {
    ...state,
    base: {
      ...state.base,
      byId: newById,
    },
  };
};
